import { TFunction } from "i18next";
import React from "react";
import { Table } from "react-bootstrap";

export interface ISubscriptionReportTable {
    name: string,
    plan: string,
    status: string,
    createdAt: string,
    dueDate: string,
}

export interface ISubscriptionReportTableProps {
    response: ISubscriptionReportTable[],
    translate: TFunction<"reports", undefined>
}
export const SubscriptionReportTable: React.FC<ISubscriptionReportTableProps> = ({ response, translate }) => {
    return (
        <Table striped responsive hover size="sm" style={{ fontSize: "12px" }}>
            <thead>
                <tr>
                    <th>{translate('table_column_one')}</th>
                    <th>{translate('table_column_two')}</th>
                    <th>{translate('table_column_three')}</th>
                    <th>{translate('table_column_four')}</th>
                    <th>{translate('table_column_five')}</th>
                </tr>
            </thead>
            <tbody>
                {response.map((subscription, index) =>
                    <tr key={index}>
                        <td className="text-capitalize">{subscription.name}</td>
                        <td>{translate(`plans_options.${subscription.plan}`)}</td>
                        <td>{translate(`status_options.${subscription.status}`)}</td>
                        <td>{subscription.createdAt}</td>
                        <td>{subscription.dueDate}</td>
                    </tr>
                )}
            </tbody>
        </Table>
    )
}